class DiscountAppointmentTimeOut {
    constructor() {
        const maxDateStep = 7
        this.maxDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + maxDateStep))
        !this.isInTimeOut && this.clearDiscountTimeOut()
    }

    clearDiscountTimeOut() {
        localStorage.removeItem('discountTimeOut')
    }

    setTimeOutByDay(dayStep) {
        this.timeOut = this.currentDate.setDate(this.currentDate.getDate() + dayStep)
    }

    setTimeOutByHour(hourStep) {
        this.timeOut = this.currentDate.setHours(this.currentDate.getHours() + hourStep)
    }

   get isInTimeOut() {
       return !!(this.timeOut && +this.timeOut > new Date().getTime() && this.timeOut < this.maxDate)
   }

   set timeOut(value) {
       localStorage.setItem('discountTimeOut', value)
   }

   get timeOut() {
       return localStorage.getItem('discountTimeOut')
   }

   get currentDate() {
        return new Date()
   }
}

